<div class="container mx-auto max-w-3xl px-4 md:px-6 pt-8 pb-4">
  <!-- Header -->
  <div class="mb-6">
    <h2 class="text-2xl font-medium">Gebruiker verplaatsen</h2>
    @if (targetUser(); as u) {
      <p class="text-sm text-gray-500 mt-0.5">{{ u.displayName }}</p>
    }
  </div>

  <div class="bg-white rounded-lg p-6 shadow-sm">
    <mat-stepper [linear]="true" (selectionChange)="onStepChange($event)">

      <!-- Always show step numbers instead of edit/done icons -->
      <ng-template matStepperIcon="edit" let-index="index">
        {{ index + 1 }}
      </ng-template>
      <ng-template matStepperIcon="done" let-index="index">
        {{ index + 1 }}
      </ng-template>

      <!-- Step 1: Target unit selection -->
      <mat-step [completed]="!!selectedUnitId()">
        <ng-template matStepLabel>Verplaatsen</ng-template>

        <div class="py-4 space-y-4">
          <div class="bg-blue-50 border border-blue-200 rounded-lg p-4 text-sm text-blue-800">
            <p class="font-medium mb-1">Wat gebeurt er bij het verplaatsen?</p>
            <ul class="list-disc ml-4 space-y-0.5">
              <li>De gebruiker wordt verplaatst naar een andere unit</li>
              <li>De gebruiker wordt uitgelogd en moet opnieuw inloggen</li>
              <li>De gebruiker wordt verwijderd als editor van cliënten in de huidige unit</li>
            </ul>
          </div>

          <mat-form-field class="w-full" subscriptSizing="dynamic">
            <mat-label>Ontvangende unit</mat-label>
            <mat-select
              [ngModel]="selectedUnitId()"
              (ngModelChange)="selectedUnitId.set($event)"
            >
              @for (unit of availableUnits(); track unit._id) {
                <mat-option [value]="unit._id">{{ unit.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="flex justify-end gap-2 mt-4">
          <button mat-button (click)="cancel()">Annuleren</button>
          <button
            mat-flat-button
            matStepperNext
            [disabled]="!selectedUnitId()"
          >
            Volgende
          </button>
        </div>
      </mat-step>

      <!-- Step 2: Summary & Confirmation -->
      <mat-step>
        <ng-template matStepLabel>Bevestigen</ng-template>

        <div class="py-4 space-y-4">
          <h3 class="font-medium text-lg">Samenvatting</h3>

          <div class="bg-gray-50 rounded-lg p-4 space-y-2 text-sm">
            <div class="flex justify-between">
              <span class="text-gray-500">Gebruiker</span>
              <span class="font-medium">{{ targetUser()?.displayName }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-500">Account ID</span>
              <span class="font-medium">{{ targetUser()?.username }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-500">Van unit</span>
              <span class="font-medium">{{ sourceUnit()?.name }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-500">Naar unit</span>
              <span class="font-medium">{{ selectedUnit()?.name }}</span>
            </div>
          </div>

          <div class="bg-orange-50 border border-orange-200 rounded-lg p-4 text-sm text-orange-800">
            <p>
              <strong>Let op:</strong>
              Na bevestiging wordt de gebruiker uitgelogd en moet opnieuw inloggen.
            </p>
          </div>
        </div>

        <div class="flex justify-end gap-2 mt-4">
          <button mat-button matStepperPrevious>Terug</button>
          <button
            mat-flat-button
            color="primary"
            [disabled]="isSubmitting()"
            (click)="submit()"
          >
            @if (isSubmitting()) {
              Bezig met verplaatsen...
            } @else {
              Verplaatsen bevestigen
            }
          </button>
        </div>
      </mat-step>
    </mat-stepper>
  </div>
</div>
